<template>
    <div>
        <base-header type="primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!--Charts-->
        
        </base-header>

        <div class="container-fluid pt-4">
            <div class="row">
                <table class="table tablesorter hover table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item) in list" :key="item['.key']">
                        <td>
                            <router-link
                                                :to="{ name: 'accident data', params: { id: item.id } }"
                                                class="text-dark font-weight-normal text-uppercase">
                                    {{item.id}}
                                </router-link></td>
                        <td>
                            {{item.date}}
                        </td>
                        <td>
                            <div class="align-middle d-flex justify-content-start">
                                <!-- <router-link
                                                :to="{ name: 'form data', params: { id: item.id } }"
                                                class=" btn btn-sm btn-success btn-icon-only rounded-circle mt-1">
                                    <i class="fa fa-eye"></i>
                                </router-link> -->
                                <router-link
                                                :to="{ name: 'accident data', params: { id: item.id } }"
                                                class=" btn btn-sm btn-primary btn-icon-only rounded-circle mt-1">
                                    <i class="fa fa-eye"></i>
                                </router-link>
                                <button @click="deleteForm(item.id)" type="button"
                                        class=" btn btn-sm btn-danger btn-icon-only rounded-circle mt-1">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>

    window.$ = window.jQuery = require('jquery');
    import firebase from '../config/db.js';
    import moment from 'moment'
    import swal from 'sweetalert2'

    export default {
        name: 'accidents',
        data() {
            return {
                list: [],
                publicPath: process.env.BASE_URL,
            }
        },
        mounted: function () {
            this.getFormList();
        },
        methods: {
            getFormList: function () {
                var collection = [];
                firebase.firestore().collection("accidents").orderBy("date", 'desc').get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        collection.push({
                            id:doc.id,
                            date: moment( doc.data().date.toDate()).format('MMMM Do YYYY, h:mm:ss A'),
                        });
                    });
                });
                this.list = collection;
            },
            deleteForm: function (data_key) {
                var that = this;

                swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: !0,
                    icon: 'warning',
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then((result) => {
                    if (result.value) {
                        firebase.firestore().collection("accidents").doc(data_key).delete().then(function() {
                            swal.fire({
                                text: "Accident deleted successfully...",
                                type: "success",
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            that.getFormList();
                        }).catch(function(error) {
                            swal({
                                text: error,
                                type: "error",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        });
                    }
                });
            }
        },
        filters: {
            readableDate: function (value) {
                if (!value || typeof value === 'undefined'){
                    return '';
                }else if(value instanceof Date){
                    return moment( value ).format('MMMM Do YYYY, h:mm:ss A');
                }
                return '';
            }
        }

    };
</script>

